import type { TextAreaFormGroupProps } from "@amzn/storm-ui";
import { TextArea } from "@amzn/storm-ui";
import React from "react";

import type { InputComponentProps } from "./Input";
import { LabelEndComponent } from "./LabelEndComponent";

export interface TextAreaComponentProps
    extends Omit<InputComponentProps, "type"> {}

export const TextAreaComponent: React.FunctionComponent<
    TextAreaComponentProps
> = (props) => {
    const {
        disabled,
        value,
        setValue,
        dimension,
        tooltip,
        label,
        warningMessage,
        optional,
    } = props;

    const statusType =
        warningMessage && warningMessage.length > 0 ? "warning" : undefined;
    const conditionalParameters = {} as TextAreaFormGroupProps;
    const labelEndProps = { tooltip, optional };
    conditionalParameters.renderLabelEnd = (
        <LabelEndComponent {...labelEndProps} />
    );
    return (
        <TextArea
            {...conditionalParameters}
            id={dimension}
            data-testid={`${dimension}-text-area`}
            label={label}
            disabled={disabled}
            statusType={statusType}
            message={warningMessage}
            value={value}
            fullWidth
            onChange={(e) => setValue(e.target.value)}
        />
    );
};
